import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { AnalysisFailureCode } from "./Analysis";

// Причина `failed` по коду. `Record` по union из контракта: новый код не соберётся без текста.
export const FAILURE_MESSAGES: Record<AnalysisFailureCode, MessageDescriptor> = {
  match_not_found: msg({
    id: "analysis.failure.match_not_found",
    message: "This match is not in Deadlock data.",
  }),
  match_wait_timeout: msg({
    id: "analysis.failure.match_wait_timeout",
    message: "The match never appeared in Deadlock data. Try again later.",
  }),
  match_too_old: msg({
    id: "analysis.failure.match_too_old",
    message: "This match is too old: Deadlock no longer gives out its data.",
  }),
  deadlock_api_unavailable: msg({
    id: "analysis.failure.deadlock_api_unavailable",
    message: "The Deadlock data service is unavailable right now. Try again later.",
  }),
  invalid_match_data: msg({
    id: "analysis.failure.invalid_match_data",
    message: "The match data is broken, so this match can't be analyzed.",
  }),
  unsupported_game_mode: msg({
    id: "analysis.failure.unsupported_game_mode",
    message:
      "We only analyze regular 6v6 matches: Street Brawl and other modes are played on a different map.",
  }),
  internal_error: msg({
    id: "analysis.failure.internal_error",
    message: "Something went wrong on our side. Try again.",
  }),
};
